<script setup lang="ts">
import { nextTick, onMounted, ref, watch } from "vue";
import { ToggleGroupItem, ToggleGroupRoot } from "reka-ui";

const props = defineProps<{
  modelValue: string;
  options: { value: string; label: string }[];
}>();

const emit = defineEmits<{ (e: "update:modelValue", value: string): void }>();

const containerRef = ref<HTMLElement>();
const itemRefs = ref<HTMLElement[]>([]);
const pillStyle = ref({ left: "0px", width: "0px" });

function updatePill() {
  if (!containerRef.value) return;
  const index = props.options.findIndex((o) => o.value === props.modelValue);
  if (index === -1) return;
  const item = itemRefs.value[index];
  if (!item) return;
  const containerRect = containerRef.value.getBoundingClientRect();
  const itemRect = item.getBoundingClientRect();
  pillStyle.value = {
    left: `${itemRect.left - containerRect.left + (index === 0 ? 2 : 0)}px`,
    width: `${itemRect.width - (index === props.options.length - 1 ? 2 : 0)}px`,
  };
}

onMounted(updatePill);
watch(
  () => props.modelValue,
  () => nextTick(updatePill)
);
</script>

<template>
  <div
    ref="containerRef"
    class="relative inline-flex rounded-xl text-xs"
    style="
      backdrop-filter: blur(20px);
      box-shadow: inset 0 2px 10px rgba(1, 27, 38, 0.2);
    "
  >
    <div
      class="absolute top-[2px] bottom-[2px] bg-midblue rounded-xl transition-all duration-200 pointer-events-none shadow-sm"
      :style="pillStyle"
    />
    <ToggleGroupRoot
      type="single"
      :model-value="modelValue"
      @update:model-value="(val) => val && emit('update:modelValue', val)"
      class="flex"
    >
      <ToggleGroupItem
        v-for="(option, i) in options"
        :key="option.value"
        :value="option.value"
        :ref="(el: any) => { if (el) itemRefs[i] = el.$el ?? el }"
        class="relative z-10 py-1 px-3 cursor-pointer outline-none select-none text-sm"
      >
        {{ option.label }}
      </ToggleGroupItem>
    </ToggleGroupRoot>
  </div>
</template>
